<script>
	import { onMount } from 'svelte'
	import { adminUpdateDrinksEntry } from '../AdminModule.svelte'
	import { urlAdmin } from '../../../library/scripts/Setup.svelte'
	import TwoCols from '../../../library/columLayouts/TwoCols.svelte'
	import DrinksPreview from './DrinksPreview.svelte'
	import DrinksEntry from './DrinksEntry.svelte'

	//holds the menu objects
	let menu = []

	//load the menu from db
	const fetch_menu = async () => {
		const fetchDrinks = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'get_drinks',
			}),
		})

		const dataResponse = await fetchDrinks.json()

		if (dataResponse.fetch === 0) {
			adminUpdateDrinksEntry.set('[]')
			sessionStorage.setItem('drinks', '[]')
			return
		}
		dataResponse.fetch.forEach((item) => {
			let tmpItem = {
				category: item[0],
				id: item[1],
				name: item[2],
				quantity: item[3],
				price: item[4],
				currency: item[5],
				menuorder: item[6],
			}

			//add the item at the beginning of the array menu
			menu.unshift(tmpItem)
		})

		adminUpdateDrinksEntry.set(JSON.stringify(menu))
		sessionStorage.setItem('drinks', JSON.stringify(menu))
	}
	onMount(() => {
		fetch_menu()
	})
</script>

<body style="background-color: black;">
	<TwoCols column="290px" alignVertical="start">
		<div slot="column1">
			<DrinksEntry />
		</div>

		<div slot="column2">
			<DrinksPreview />
		</div>
	</TwoCols>
</body>
